<template>
  <div class="content" id="bom-tool">
    <h1 id="customer-bom-upload-title">
      {{ pageTitle }}
    </h1>
    <div class="content-body">
      <div class="block">
        <div class="text-align-right" style="margin-bottom: 15px;">
          <Button type="text" id="customer-bom-template-download" to="/downloads/NexPCB_Standard_E_BOM_For_Pangu_System_V3.0.xlsx" target="_blank"><Icon type="md-download"></Icon> {{ $t('bom_tool.edit.upload.download_template') }}</Button>
        </div>
        <BomUploader></BomUploader>
      </div>
    </div>
  </div>
</template>
<script>
import BomUploader from './components/bom-uploader'
export default {
  name: 'BomImport',
  components: {
    BomUploader
  },
  computed: {
    pageTitle () {
      document.title = this.$t('menu.bom.upload')
      return document.title
    }
  }
}
</script>
